import { FiMapPin, FiMail } from "react-icons/fi";
import { IoCallOutline } from "react-icons/io5";

const ContactFooter = () => {
  const email = "support@rwndynamics.com";
  const mailtoLink = `mailto:${email}`;
  const Infoemail = "info@rwdynamics.com";
  const InfomailtoLink = `mailto:${Infoemail}`;
  return (
    <div className=" py-5 bg-black text-center text-sm md:space-x-20 font-light text-white md:flex justify-center items-center ">
      {/* FIrst Item */}
      <div className="">
        {/* Icon */}
        <FiMapPin size={40} className="mx-auto my-4" />
        <p>
          Suite A13 Saham <br /> Plaza Wuse 2<br />
          FCT Abuja
        </p>
      </div>
      {/* Second Item */}
      <div>
        <IoCallOutline size={40} className="mx-auto my-4" />
        <div>
          <p>+2348033917294</p>
        </div>
      </div>
      {/* Third Item */}
      <div>
        <FiMail size={40} className="mx-auto my-4" />
        <p>
          {" "}
          <a href={InfomailtoLink} target="_blank" className="font-medium">
            {Infoemail}
          </a>
        </p>
        <p>
          <span>Support: </span>{" "}
          <a href={mailtoLink} target="_blank" className="font-bold">
            support@rwndynamics.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default ContactFooter;
